import React from 'react'

const CarIcon = ({ width = '24', height = '25' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12.3346V12.7721C3 13.1194 2.88194 13.411 2.64583 13.6471C2.40972 13.8832 2.11111 14.0013 1.75 14.0013C1.40278 14.0013 1.10778 13.8796 0.865 13.6363C0.621667 13.3935 0.5 13.0985 0.5 12.7513V6.5013L2.25 1.5013C2.33333 1.2513 2.48278 1.04991 2.69833 0.897136C2.91333 0.744358 3.15278 0.667969 3.41667 0.667969H12.5833C12.8472 0.667969 13.0869 0.744358 13.3025 0.897136C13.5175 1.04991 13.6667 1.2513 13.75 1.5013L15.5 6.5013V12.7721C15.5 13.1194 15.3819 13.411 15.1458 13.6471C14.9097 13.8832 14.6111 14.0013 14.25 14.0013C13.9028 14.0013 13.6078 13.8796 13.365 13.6363C13.1217 13.3935 13 13.0985 13 12.7513V12.3346H3ZM2.83333 4.83464H13.1667L12.2917 2.33464H3.70833L2.83333 4.83464ZM4.25 9.83464C4.59722 9.83464 4.89222 9.71297 5.135 9.46964C5.37833 9.22686 5.5 8.93186 5.5 8.58464C5.5 8.23741 5.37833 7.94241 5.135 7.69964C4.89222 7.4563 4.59722 7.33464 4.25 7.33464C3.90278 7.33464 3.60778 7.4563 3.365 7.69964C3.12167 7.94241 3 8.23741 3 8.58464C3 8.93186 3.12167 9.22686 3.365 9.46964C3.60778 9.71297 3.90278 9.83464 4.25 9.83464ZM11.75 9.83464C12.0972 9.83464 12.3922 9.71297 12.635 9.46964C12.8783 9.22686 13 8.93186 13 8.58464C13 8.23741 12.8783 7.94241 12.635 7.69964C12.3922 7.4563 12.0972 7.33464 11.75 7.33464C11.4028 7.33464 11.1078 7.4563 10.865 7.69964C10.6217 7.94241 10.5 8.23741 10.5 8.58464C10.5 8.93186 10.6217 9.22686 10.865 9.46964C11.1078 9.71297 11.4028 9.83464 11.75 9.83464Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default CarIcon
